<!-- 视频模块 -->
<template>
  <div class="module-video">
    <div
      class="container"
      :class="{
        'container--full': config['wildscreen'] || config['fullscreen'],
      }"
    >
      <default-video :config="config" v-if="config['show_type'] === 'default'" />
      <background-video
        v-else
        :config="config"
      />
    </div>
  </div>
</template>

<script>
import BackgroundVideo from './BackgroundVideo.vue'
import DefaultVideo from './DefaultVideo.vue'
export default {
  components: { DefaultVideo, BackgroundVideo },
  name: 'vModuleVideo',
  props: {
    config: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.module-video {
}
</style>
